/**
 * Loader for suspense fallback
 * @author: Sarathavs
 */
import React from 'react';

const PageLoader: React.FC = () => (
  <div className="fx-page-loader">
    <svg className="fx-page-loade-svg" viewBox="0 0 100 100" width="10em" height="10em">
      <path
        stroke="none"
        d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50"
        fill="#103046"
        transform="rotate(179.719 50 51)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values="0 50 51;360 50 51"
          keyTimes="0;1"
          dur="1s"
          begin="0s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  </div>
);

export default PageLoader;
